import React from 'react';
import { Image, Row, Col, Button } from 'react-bootstrap';
import { MoveTypeTStrings } from './QuoteScreen';
import apartmentIconImg from "../../assets/images/apartment_icon.png";
import houseIconImg from "../../assets/images/house_icon.png";
const images = {
    apartmentIcon: apartmentIconImg,
    houseIcon: houseIconImg,
}
const options = {
    apartment: {
        "ST": "Studio",
        "A1": "1 Bedroom",
        "A2": "2 Bedrooms",
        "A3": "3+ Bedrooms",
    },
    house: {
        "H1": "1 Bedroom",
        "H2": "2 Bedrooms",
        "H3": "3 Bedrooms",
        "H4": "4+ Bedrooms",
    }
}

export interface IMoveTypeProps {
    moveType: MoveTypeTStrings | null
    homeSize: string
    onChangeInputs(key: string, value: any): void
}

const MoveType: React.FC<IMoveTypeProps> = ({ moveType, homeSize, onChangeInputs }) => {


    const renderOptions = () => {
        if (moveType) {
            return Object.keys(options[moveType]).map((key, index) => {
                return (
                    <div key={index} onClick={() => onChangeInputs("homeSize", key)}>
                        <span className={`btn  ${homeSize == key ? "btn-outline-info" : "btn-defualt"}`} >
                            <span>{options[moveType][key]}</span>
                        </span>
                    </div>

                )
            })
        }
    }


    const changeType = (newMoveType: MoveTypeTStrings) => {
        onChangeInputs("moveType", newMoveType)
    }
    return (
        <div className="text-center mb-2">
            <h3 >Move Type</h3>
            <Row>
                <Col>
                    <span className={`btn  ${moveType == "apartment" ? "btn-outline-info" : "btn-defualt"}`} onClick={() => changeType("apartment")}>
                        <Image style={{ width: 100, height: 100 }} src={images.apartmentIcon} />
                        <p>Apartment</p>
                    </span>
                </Col>
                <Col>
                    <span
                        className={`btn  ${moveType == "house" ? "btn-outline-info" : "btn-defualt"}`}
                        onClick={() => changeType("house")} >
                        <Image style={{ width: 100, height: 100 }} src={images.houseIcon} />
                        <p>House</p>
                    </span>
                </Col>
            </Row>

            <div>
                {renderOptions()}
            </div>
        </div>
    );
}
export default MoveType
export { MoveType };